export default __webpack_public_path__ + "static/media/concrete5.11e5ea24.svg";